import axios from 'axios';
import { requestsPost, requestsGet, requestsFile } from './axiosFun';
// const baseUrl = '/api'
const ipName = baseUrl;
// const ipName = '/jnrcb';
// 登录接口 
export const login = (params) => { return requestsGet(ipName + "/UserInfo/companyLogin", params) };
export const login2 = (params) => { return requestsPost(ipName + "/CloudWeight/login", params) };
// 获取系统接口 
export const getUserDiskSize = (params) => { return requestsGet(ipName + "/DataInfo/getUserDiskSize", params) };
// 称重数据获取tab显示  
export const getWeightData = (params) => { return requestsGet(ipName + "/DataInfo/webDataSum", params) };
//点击每行数据，进入详情页，展示列表数据
// export const getDayTypeList = (params) => { return requestsGet("/datainfo/webDataListByDate1", params) };
export const getDayTypeList = (params) => { return requestsGet(ipName + "/DataInfo/webDataListByDatePage", params) };
// 查看图片数据
export const getPictureList = (params) => { return requestsGet(ipName + "/datainfo/webGetPicByUID", params) };
// 查看编辑数据
export const getEditList = (params) => { return requestsGet(ipName + "/datainfo/webDataByUID", params) };
// 保存编辑数据new
export const saveNewData = (params) => { return requestsPost(ipName + "/DataInfo/web_postWeightData", params) };

// 统计查询
//2-1  查询列表  
export const getSearchList = (params) => { return requestsGet(ipName + "/DataInfo/webSearchDataPageWeb", params) };
export const getSearchHistoryList = (params) => { return requestsGet(ipName + "/DataInfo/webSearchDataPageWeb_History", params) };

export const getBnoList = (params) => { return requestsGet(ipName + "/UserInfo/getCompanyLocatIDList", params) };
// 获取表头显示字段
export const getTableHeaderList = (params) => { return requestsGet(ipName + "/DataInfo/webDataFilesShow_Manage_List", params) };


//2-1  导出  
export const getExportData = (params) => { return requestsGet(ipName + "/DataInfo/webSearchData2Excel3", params) };
// 2-2  日报表  
export const getDayReportList = (params) => { return requestsGet(ipName + "/DataInfo/webDataSum", params) };
// 2-6  车次汇总
export const getCarSummary = (params) => { return requestsGet(ipName + "/DataInfo/webCarSum", params) };
// 2-7  货名汇总
export const getGoodsSummary = (params) => { return requestsGet(ipName + "/DataInfo/webGoodsSum", params) };
// 2-8  发货单位汇总
export const getDeliverSummary = (params) => { return requestsGet(ipName + "/DataInfo/webFDeptSum", params) };
// 2-9  收货单位汇总
export const getReceiveSummary = (params) => { return requestsGet(ipName + "/DataInfo/webSDeptSum", params) };
// 2-10  充值金额汇总
export const getRechargeSummary = (params) => { return requestsGet(ipName + "/DataInfo/webRechargeSum", params) };
// 2-11  充值历史
export const getPriceSummary = (params) => { return requestsGet(ipName + "/DataInfo/webRechargeLog", params) };

// 2-13  数据汇总
export const dataCarSummary = (params) => { return requestsPost(ipName + "/DataInfo/webSum_car", params) };
export const dataRechargeSummary = (params) => { return requestsPost(ipName + "/DataInfo/webSum_Recharge", params) };
export const dataGoodsSummary = (params) => { return requestsPost(ipName + "/DataInfo/webSum_goods", params) };
export const dataEnterpriseSummary = (params) => { return requestsPost(ipName + "/DataInfo/webSum_enterprise", params) };

//4-0 单位管理
export const getReceiveManage = (params) => { return requestsPost(ipName + "/RemoteConfig/customer_Web_List", params) };
export const deleteUnit = (params) => { return requestsPost(ipName + "/RemoteConfig/customer_Web_DeleteOne", params) };
// 编辑
export const unitEdit = (params) => { return requestsPost(ipName + "/RemoteConfig/customer_Web_Edit", params) };
// 新增
export const unitAdd = (params) => { return requestsPost(ipName + "/RemoteConfig/customer_Web_Add", params) };

//4-2 修改密码
export const editPassword = (params) => { return requestsGet(ipName + "/userinfo/companyChangePWD", params) };
export const getInitFiled = (params) => { return requestsGet(ipName + "/Manage/mGetAppointmentFiledsList", params) };
export const submitFiled = (params) => { return requestsGet(ipName + "/Manage/mPostAppointmentFiledsList", params) };

//4-3 车辆信息
export const carList = (params) => { return requestsGet(ipName + "/Manage/mGetCarsList", params) };
export const carList2 = (params) => { return requestsPost(ipName + "/RemoteConfig/car_Web_carList", params) };
export const deleteCar = (params) => { return requestsPost(ipName + "/RemoteConfig/car_Web_carDelete", params) };
export const carEdit = (params) => { return requestsPost(ipName + "/RemoteConfig/car_Web_carEdit", params) };
export const carAdd = (params) => { return requestsPost(ipName + "/RemoteConfig/car_Web_carAdd", params) };
//4-4 产品价格
export const productPrice = (params) => { return requestsGet(ipName + "/Manage/mGetGoodsList", params) };
export const productPrice2 = (params) => { return requestsPost(ipName + "/RemoteConfig/goods_Web_GoodsList", params) };
export const deleteProduct = (params) => { return requestsPost(ipName + "/RemoteConfig/goods_Web_GoodsDelete", params) };
export const addProduct = (params) => { return requestsPost(ipName + "/RemoteConfig/goods_Web_GoodsAdd", params) };
export const editProduct = (params) => { return requestsPost(ipName + "/RemoteConfig/goods_Web_GoodsEdit", params) };

// 客户单价
export const customerPriceList = (params) => { return requestsPost(ipName + "/RemoteConfig/CustomerPrice_Web_List", params) };
export const deleteCusPri = (params) => { return requestsPost(ipName + "/RemoteConfig/CustomerPrice_Web_GoodsPirceDelete", params) };
export const addCusPri = (params) => { return requestsPost(ipName + "/RemoteConfig/CustomerPrice_Web_GoodsPirceAdd", params) };
export const editCusPri = (params) => { return requestsPost(ipName + "/RemoteConfig/CustomerPrice_Web_GoodsPirceEdit", params) };


// 4-5 远程充值
export const accontsList = (params) => { return requestsPost(ipName + "/RemoteConfig/recharge_Web_CustomerList", params) };
export const accontsNew = (params) => { return requestsPost(ipName + "/RemoteConfig/recharge_Web_new", params) };
export const getAccontHistoryList = (params) => { return requestsPost(ipName + "/RemoteConfig/recharge_Web_RechargeHistory", params) };
// 4-11 规格
export const specList = (params) => { return requestsPost(ipName + "/RemoteConfig/Spec_Web_SpecList", params) };
export const addSpec = (params) => { return requestsPost(ipName + "/RemoteConfig/Spec_Web_SpecsAdd", params) };
export const editSpec = (params) => { return requestsPost(ipName + "/RemoteConfig/Spec_Web_SpecEdit", params) };
export const deleteSpec = (params) => { return requestsPost(ipName + "/RemoteConfig/Spec_Web_SpecDelete", params) };
// 4-8
export const settingList = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_realInput_loadFields", params) };
export const settingWordsList = (params) => { return requestsGet(ipName + "/DataInfo/webDataFilesShow_Manage_List", params) };
export const settingSave = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_realInput_saveFields", params) };
export const settingWordSave = (params) => { return requestsPost(ipName + "/DataInfo/webDataFilesShow_Manage_ListPost", params) };

// 3-1 预约审核
export const getCheckList = (params) => { return requestsGet(ipName + "/datainfo/webDataCheckListByCompanyID", params) };
export const checkItem = (params) => { return requestsGet(ipName + "/datainfo/webDataCheckByUID2506", params) };
export const getCheckFinishList = (params) => { return requestsGet(ipName + "/datainfo/webDataCheckListByCompanyID_Finish", params) };


// 验证
export const getURLReportData = (params) => { return requestsGet(ipName + "/UserInfo/getURLReportData", params) };
export const getCustomerReportData = (params) => { return requestsGet(ipName + "/UserInfo/getCustomerReportData", params) };

// 获取appid
export const getWxAppId = (params) => { return requestsGet(ipName + "/WxOperater/wxcd_getWSign", params) };

// 获取跳转小程序url
export const getUrl = (params) => { return requestsGet(ipName + "/WxOperater/wxcd_getWUScheme", params) };

// 获取参数
export const wxMainInt = (params) => { return requestsGet(ipName + "/WxOperater/wxMainInt", params) };

// 移动端
export const loginBarcode = (params) => { return requestsGet(ipName + "/UserInfo/CarNumberAndCompanyIDLogin", params) };
export const getOptions = (params) => { return requestsGet(ipName + "/DataInfo/webGetBaseInfo", params) };
export const apply = (params) => { return requestsGet(ipName + "/DataInfo/wxUploadApply3", params) };
export const getYYInfo = (params) => { return requestsPost(ipName + "/wxApply/driver_getMyApplyList", params) };
// 10948定制
export const getOrderList10948 = (params) => { return requestsPost(ipName + "/upload/dz10948_get_orderList", params) };
export const getCusList10948 = (params) => { return requestsPost(ipName + "/upload/dz10948_get_orderInfo_byCusName", params) };
export const apply10948_1 = (params) => { return requestsGet(ipName + "/DataInfo/wxUploadApply_10948_1", params) };
export const apply10948_2 = (params) => { return requestsGet(ipName + "/DataInfo/wxUploadApply_10948_2", params) };


export const getWeightList = (params) => { return requestsGet(ipName + "/datainfo/webDataListByCarAndCompanyID", params) };
export const initLogin = (params) => { return requestsGet(ipName + "/UserInfo/CarNumberAndCompanyIDLogin2", params) };
export const getWord = (params) => { return requestsGet(ipName + "/Manage/mGetAppointmentFiledsList240611", params) };
export const getWord2 = (params) => { return requestsGet(ipName + "/Manage/mGetAppointmentFiledsList", params) };
export const getInitValue = (params) => { return requestsPost(ipName + "/upload/dz10948_get_orderInfo_byOrderID", params) };
export const loginCompany = (params) => { return requestsGet(ipName + "/UserInfo/companyLogin2", params) };
export const saveArr = (params) => { return requestsGet(ipName + "/Manage/mPostAppointmentFiledsList240611", params) };
export const getWebData = (params) => { return requestsGet(ipName + "/DataInfo/webDataSum", params) };
export const getDataList = (params) => { return requestsGet(ipName + "/datainfo/webDataListByDate1", params) };
export const getDataDetails = (params) => { return requestsGet(ipName + "/datainfo/webDataByUID", params) };
export const getBroList = (params) => { return requestsGet(ipName + "/UserInfo/getCompanyLocatIDList", params) };
export const weightSearchList = (params) => { return requestsGet(ipName + "/DataInfo/webSearchDataPageWX", params) };
export const getExamineList = (params) => { return requestsGet(ipName + "/datainfo/webDataCheckListByCompanyID", params) };
export const getExamineNewList = (params) => { return requestsPost(ipName + "/wxApply/Manage_getCheck_ApplyList", params) };
export const passway = (params) => { return requestsGet(ipName + "/datainfo/webDataCheckByUID", params) };
export const passwayNew = (params) => { return requestsPost(ipName + "/wxApply/Manage_Check_ApplyInfo_only", params) };
export const changeUserPsd = (params) => { return requestsGet(ipName + "/userinfo/companyChangePWD", params) };
export const accountManageList = (params) => { return requestsGet(ipName + "/UserInfo/ManageUserList", params) };
export const resetPassword = (params) => { return requestsGet(ipName + "/UserInfo/ResetUserPWD", params) };
export const userLock = (params) => { return requestsGet(ipName + "/UserInfo/ManageUserLock", params) };
export const initAddUser = (params) => { return requestsGet(ipName + "/UserInfo/ManageGetNewUserID", params) };
export const saveAddUser = (params) => { return requestsGet(ipName + "/UserInfo/ManageUserAddNew", params) };
export const saveEditUser = (params) => { return requestsGet(ipName + "/UserInfo/ManageUserModifying", params) };
export const deleteUser = (params) => { return requestsGet(ipName + "/UserInfo/ManageUserLock", params) };
export const weightSearchRList = (params) => { return requestsGet(ipName + "/DataInfo/webSearchData", params) };
export const getWebData2 = (params) => { return requestsGet(ipName + "/DataInfo/webDataSum2", params) };
export const confirmGoodsLogin = (params) => { return requestsGet(ipName + "/UserInfo/confirmGoodsLogin", params) };
export const goodsConfirm = (params) => { return requestsGet(ipName + "/DataInfo/webGoodsConfirmListByCompanyID2", params) };

export const driverApply = (params) => { return requestsPost(ipName + "/wxApply/driver_Apply", params) };

//admin登录端
export const adminLogin = (params) => { return requestsPost(ipName + "/AdminManage/cloud_web_admin_login", params) };
export const customerList = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_Web_List", params) };
export const start = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_realInput_open", params) };
export const stop = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_realInput_close", params) };
export const SCloudBox = (params) => { return requestsPost(ipName + "/CBAdmin/Account_start", params) };
export const ECloudBox = (params) => { return requestsPost(ipName + "/CBAdmin/Account_stop", params) };
export const PCList = (params) => { return requestsPost(ipName + "/CBAdmin/equ_PcBox_list", params) };
export const PLCList = (params) => { return requestsPost(ipName + "/CBAdmin/equ_PlcBox_list", params) };
export const getVideoBoxList = (params) => { return requestsPost(ipName + "/CBAdmin/equ_plateVideoBox_list", params) };
export const PCUpdate = (params) => { return requestsPost(ipName + "/CBAdmin/equ_PcBox_update", params) };
export const PLCUpdate = (params) => { return requestsPost(ipName + "/CBAdmin/equ_PlcBox_update", params) };
export const getTableList = (params) => { return requestsPost(ipName + "/CBAdmin/admin66_getTableList", params) };
export const searchSQL = (params) => { return requestsPost(ipName + "/CBAdmin/admin66_getTableDataBySQL", params) };
export const updateSQL = (params) => { return requestsPost(ipName + "/CBAdmin/admin66_execUpdateSQL", params) };
export const getMaxCloudID = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_getMaxCloudID", params) };
export const newCustomer = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_NewCustomer", params) };
export const deleteCustomerItem = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_DeleteCustomer", params) };
export const openCustomer = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_OpenCustomer", params) };
// 编辑里的修改按钮
export const changeExpDate = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_changeExpDate", params) };
export const changeCusName = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_changeCusName", params) };
export const changeCusPWD = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_changeCusPWD", params) };
export const resetErrorCount = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_ResetErrorCount", params) };
export const changeCusRank = (params) => { return requestsPost(ipName + "/AdminManage/cloudCustomer_WebManage_changeCusRank", params) };

// 预约信息
export const applyNoCheck = (params) => { return requestsGet(ipName + "/DataInfo/wxUploadApplyNoCheck", params) };


//定制接口
export const webDataSum_10828 = (params) => { return requestsGet(ipName + "/DataInfo/webDataSum_10828", params) };



// 云称重
export const accountList = (params) => { return requestsPost(ipName + "/CloudWeightAccount/accountList", params) };
export const rankList = (params) => { return requestsPost(ipName + "/CloudWeightAccount/rankList", params) };
export const accountNew = (params) => { return requestsPost(ipName + "/CloudWeightAccount/accountNew", params) };
export const accountEdit = (params) => { return requestsPost(ipName + "/CloudWeightAccount/accountEdit", params) };
export const accountDelete = (params) => { return requestsPost(ipName + "/CloudWeightAccount/accountDelete", params) };
export const accountResetPWD = (params) => { return requestsPost(ipName + "/CloudWeightAccount/accountResetPWD", params) };
export const getWeight = (params) => { return requestsPost(ipName + "/CloudWeight/getWeight", params) };
export const getInput = (params) => { return requestsPost(ipName + "/AdminManage/webpageLoadWeightFields", params) };
export const saveWeightData = (params) => { return requestsPost(ipName + "/CloudWeight/saveWeightData", params) };
export const editWeightData = (params) => { return requestsPost(ipName + "/CloudWeight/editWeightData", params) };
export const loadWeightData = (params) => { return requestsPost(ipName + "/CloudWeight/loadWeightData", params) };
export const deleteData = (params) => { return requestsPost(ipName + "/CloudWeight/DeleteWeightDataBySID", params) };
export const loadData = (params) => { return requestsPost(ipName + "/CloudWeight/loadWeightDataBySID", params) };

// 系统管理-系统设置
export const loadFields = (params) => { return requestsPost(ipName + "/CBAdmin/cloudCustomer_webWeight_loadFields", params) };
export const getCompanyList = (params) => { return requestsPost(ipName + "/Group/companyList", params) };
export const getCompanyDelete = (params) => { return requestsPost(ipName + "/Group/companyDelete", params) };
export const saveCompanyData = (params) => { return requestsPost(ipName + "/Group/companyAdd", params) };
export const saveCompanyEdit = (params) => { return requestsPost(ipName + "/Group/companyEdit", params) };
export const wxApplyFieldsList = (params) => { return requestsPost(ipName + "/wxApply/manage_wxApplyFieldsList", params) };
export const wxApplyFieldsSave = (params) => { return requestsPost(ipName + "/wxApply/manage_wxApplyFieldsSave", params) };

// 统计查询 - 数据查询
export const dataSearchList = (params) => { return requestsPost(ipName + "/CloudWeight/searchData", params) };









// WEBPACK FOOTER //
// ./src/api/userMG.js